/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function Unpublish({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><g fill="currentColor" clipPath="url(#Unpublish_svg__a)"><path d="M4.343 2.747A6.36 6.36 0 0 1 8 1.6c.806 0 1.577.149 2.286.42A.6.6 0 0 0 10.714.9 7.6 7.6 0 0 0 8 .4a7.6 7.6 0 0 0-2.904.575l-.005.002a7.6 7.6 0 0 0-1.718.993.6.6 0 0 0 .731.952q.115-.089.234-.172zM2.812 3.263a.6.6 0 0 1 .11.841c-.339.44-.621.926-.837 1.446a.6.6 0 1 1-1.108-.46 7.6 7.6 0 0 1 .993-1.717.6.6 0 0 1 .842-.11M1.137 6.49a.6.6 0 0 1 .517.673 6.5 6.5 0 0 0 0 1.674.6.6 0 0 1-1.19.155 7.7 7.7 0 0 1 0-1.984.6.6 0 0 1 .673-.517M1.301 10.125a.6.6 0 0 1 .784.325c.216.52.498 1.005.837 1.446a.6.6 0 1 1-.952.731 7.6 7.6 0 0 1-.993-1.718.6.6 0 0 1 .324-.784M3.263 13.188a.6.6 0 0 1 .841-.11q.115.089.234.172l.005.003A6.36 6.36 0 0 0 8 14.4c1.36 0 2.62-.424 3.657-1.147a.6.6 0 0 1 .686.984A7.57 7.57 0 0 1 8 15.6q-.504 0-.992-.064a7.6 7.6 0 0 1-1.912-.51l-.005-.003a7.6 7.6 0 0 1-1.718-.993.6.6 0 0 1-.11-.842M13.076 12.924a.6.6 0 0 1 0-.848c.879-.88 1.108-1.661 1.338-2.705.163-.74.075-1.269-.08-2.032a3.4 3.4 0 0 0-.946-1.74 3.5 3.5 0 0 0-1.777-.933 3.53 3.53 0 0 0-2.008.194 3.45 3.45 0 0 0-1.556 1.255c-.369.544-.57 1.18-.58 1.83l1.198-.68a.61.61 0 0 1 .825.221.59.59 0 0 1-.218.814L6.756 9.73a.61.61 0 0 1-.825-.221L4.478 7.033a.59.59 0 0 1 .218-.814.61.61 0 0 1 .826.222l.752 1.281c.05-.814.32-1.602.78-2.281A4.65 4.65 0 0 1 9.15 3.749a4.73 4.73 0 0 1 2.692-.261 4.7 4.7 0 0 1 2.388 1.256A4.6 4.6 0 0 1 15.51 7.1c.16.788.297 1.528.076 2.528-.247 1.123-.54 2.174-1.662 3.295a.6.6 0 0 1-.848 0" /></g><defs><clipPath id="Unpublish_svg__a"><path fill="#fff" d="M0 0h16v16H0z" /></clipPath></defs></svg>;
}
;